export default __webpack_public_path__ + "static/media/3.067df66c.png";